import { Loading } from '@carbon/react';

import { useAuthController } from 'core/user/auth';
import useMount from 'utils/hooks/useMount';

const AuthCallback = () => {
  const { completeLogin } = useAuthController();

  useMount(completeLogin);

  return <Loading withOverlay active />;
};

export default AuthCallback;
